import { BrandSchema } from 'src/models/brand/schema';
import { Product } from 'src/models/product/schema';

export const brandName = (product: Pick<Product, 'brandId'>, brands: BrandSchema[]): string => {
  if (product.brandId) {
    return brands.find((brand) => brand.brandId === product.brandId)?.name ?? '';
  }
  return '';
};
